<ng-container *ngIf="account">
  <greco-account-details *ngIf="showDetails" [account]="account"></greco-account-details>
  <greco-account-payment-methods (refreshed)="config.refresh()" [account]="account"></greco-account-payment-methods>
  <greco-account-reconciliation-config #config [account]="account"></greco-account-reconciliation-config>
  <greco-account-royalties [account]="account"></greco-account-royalties>
  <greco-account-admin-fee [account]="account"></greco-account-admin-fee>
  <ng-content></ng-content>
</ng-container>
